import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';
import { getGeocode, getLatLng, getZipCode } from 'use-places-autocomplete';
import { useGmapsScript } from './use-gmaps-script';
export var useAddressAdditionalFields = function useAddressAdditionalFields(_ref) {
  var addressString = _ref.addressString;

  var _useState = useState({}),
      data = _useState[0],
      setData = _useState[1];

  var isScriptReady = useGmapsScript({
    libraries: 'places'
  });
  useEffect(function () {
    if (!addressString || !isScriptReady) return;
    getLocationAddressFields(addressString).then(function (data) {
      return setData(data);
    })["catch"](function (e) {
      return e;
    });
  }, [addressString, isScriptReady]);
  return data;
};
export var getLocationAddressFields = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(addressString) {
    var data, addressComponents, getLnNameValue, country, locality, administrativeAreaLevelOne, administrativeAreaLevelTwo, street_number, postalCode, _getLatLng, lat, lng, addressData;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getGeocode({
              address: addressString
            });

          case 2:
            data = _context.sent;
            addressComponents = data[0].address_components;

            getLnNameValue = function getLnNameValue(key) {
              var _addressComponents$fi, _addressComponents$fi2;

              return (_addressComponents$fi = (_addressComponents$fi2 = addressComponents.find(function (c) {
                return c.types.includes(key);
              })) === null || _addressComponents$fi2 === void 0 ? void 0 : _addressComponents$fi2.long_name) !== null && _addressComponents$fi !== void 0 ? _addressComponents$fi : '';
            };

            country = getLnNameValue('country');
            locality = getLnNameValue('locality');
            administrativeAreaLevelOne = getLnNameValue('administrative_area_level_1');
            administrativeAreaLevelTwo = getLnNameValue('administrative_area_level_2');
            street_number = getLnNameValue('street_number');
            postalCode = getZipCode(data[0], false);
            _getLatLng = getLatLng(data[0]), lat = _getLatLng.lat, lng = _getLatLng.lng;
            addressData = {
              address: addressString,
              address_lat: lat,
              address_lon: lng,
              locality: locality,
              country: country,
              postal_code: postalCode,
              administrative_area_level_1: administrativeAreaLevelOne,
              administrative_area_level_2: administrativeAreaLevelTwo,
              street_number: street_number
            };
            return _context.abrupt("return", addressData);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getLocationAddressFields(_x) {
    return _ref2.apply(this, arguments);
  };
}();